var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3DIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#52C41A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_1721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6286 6.85645H18.1715C18.3079 6.85645 18.4387 6.91063 18.5351 7.00708C18.6316 7.10352 18.6858 7.23433 18.6858 7.37073V15.5993C18.6858 15.7357 18.6316 15.8665 18.5351 15.963C18.4387 16.0594 18.3079 16.1136 18.1715 16.1136H5.82862C5.69222 16.1136 5.56141 16.0594 5.46496 15.963C5.36851 15.8665 5.31433 15.7357 5.31433 15.5993V7.37073C5.31433 7.23433 5.36851 7.10352 5.46496 7.00708C5.56141 6.91063 5.69222 6.85645 5.82862 6.85645H7.37147",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9714 16.1143L9.94287 18.6857",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0286 16.1143L14.0571 18.6857",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91431 18.6855H15.0857",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4343 7.22706C11.4786 7.11302 11.5563 7.01502 11.6572 6.94592C11.7582 6.87682 11.8777 6.83984 12 6.83984C12.1223 6.83984 12.2418 6.87682 12.3428 6.94592C12.4437 7.01502 12.5214 7.11302 12.5657 7.22706L13.224 8.91392H14.9829C15.1079 8.91576 15.2296 8.95493 15.3322 9.0264C15.4348 9.09788 15.5138 9.1984 15.5589 9.31506C15.5936 9.4245 15.5966 9.54154 15.5674 9.65261C15.5383 9.76367 15.4783 9.86419 15.3943 9.94249L13.8412 11.3208L14.4994 12.6373C14.559 12.7529 14.5792 12.8848 14.5569 13.0129C14.5347 13.1411 14.4711 13.2584 14.376 13.3471C14.2832 13.4397 14.1629 13.4998 14.0331 13.5183C13.9033 13.5368 13.771 13.5128 13.656 13.4499L12 12.5448L10.344 13.4499C10.229 13.5128 10.0967 13.5368 9.9669 13.5183C9.8371 13.4998 9.71681 13.4397 9.62401 13.3471C9.5289 13.2584 9.46537 13.1411 9.44308 13.0129C9.4208 12.8848 9.44099 12.7529 9.50058 12.6373L10.1589 11.3208L8.60573 9.94249C8.5138 9.86084 8.44883 9.75319 8.41945 9.6338C8.39006 9.51441 8.39763 9.38891 8.44115 9.27392C8.49248 9.16495 8.57409 9.07307 8.67623 9.00923C8.77836 8.94539 8.89672 8.9123 9.01715 8.91392H10.776L11.4343 7.22706Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_1721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.7998)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DIcon);
export default __webpack_public_path__ + "static/media/3d_icon.3a5986f587d40ae5d4c1452a9c20dcd0.svg";
export { ForwardRef as ReactComponent };